import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/sipl-content";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="section-y bg-sipl-bg"
    >
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="text-sm uppercase tracking-[0.22em] text-sipl-secondary mb-4 dash-accent">
              What we do
            </div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-sipl-primary font-semibold tracking-tight leading-[1.08]">
              Four service pillars,
              <br className="hidden md:block" /> one delivery discipline.
            </h2>
          </div>
          <p className="text-sipl-fg/70 max-w-md">
            From utility-scale solar to ground-level water access — every SIPL
            engagement is built on engineering, finance and execution rigour.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {SERVICES.map((s, idx) => {
            const Icon = s.icon;
            return (
              <motion.article
                key={s.id}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.55, delay: idx * 0.08 }}
                data-testid={`service-card-${s.id}`}
                className="sipl-card group overflow-hidden flex flex-col"
              >
                <div className="relative aspect-[16/9] overflow-hidden bg-sipl-mute">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className={`absolute top-4 left-4 w-11 h-11 rounded-md flex items-center justify-center backdrop-blur-md bg-white/90 ${s.accent}`}>
                    <Icon className="w-5 h-5" />
                  </div>
                </div>
                <div className="p-6 lg:p-8 flex-1 flex flex-col">
                  <h3 className="font-heading text-xl lg:text-2xl font-medium text-sipl-primary tracking-tight">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-sipl-fg/70 text-sm leading-relaxed">
                    {s.blurb}
                  </p>
                  <ul className="mt-5 grid sm:grid-cols-2 gap-x-4 gap-y-2.5">
                    {s.items.map((it) => {
                      const Ii = it.icon;
                      return (
                        <li
                          key={it.text}
                          className="flex items-center gap-2 text-sm text-sipl-fg/80"
                        >
                          <Ii className="w-4 h-4 text-sipl-secondary shrink-0" />
                          {it.text}
                        </li>
                      );
                    })}
                  </ul>
                  <div className="mt-auto pt-6">
                    <a
                      href="#contact"
                      onClick={(e) => {
                        e.preventDefault();
                        document
                          .querySelector("#contact")
                          ?.scrollIntoView({ behavior: "smooth" });
                      }}
                      data-testid={`service-learn-more-${s.id}`}
                      className="link-underline text-sm font-medium text-sipl-primary group-hover:text-sipl-accent transition-colors"
                    >
                      Learn more <ArrowUpRight className="w-4 h-4" />
                    </a>
                  </div>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
